import {
  ComponentProps,
  CSSProperties,
  Fragment,
  ReactNode,
  useMemo,
} from 'react';
import { Card } from 'antd';
import { observer } from 'mobx-react-lite';

import { UPermissionsName } from 'app/railways/domains/access/core/permissions';
import { CanAccess } from 'app/railways/domains/access/features/permissions/ui/can-access';

import { PageContent } from './ui/page-content';

type AppPageProps = {
  children: ReactNode;
  perm?: UPermissionsName | '*' | Array<UPermissionsName>;
  noWrapper?: boolean;
  style?: CSSProperties;
};

const pageContentStyle: CSSProperties = { padding: 0 };

export const AppPage = observer(
  ({ children, style = {}, perm = '*', noWrapper = false }: AppPageProps) => {
    const Wrapper = useMemo(
      () =>
        observer((props: ComponentProps<typeof PageContent>) =>
          noWrapper ? (
            <Fragment children={props.children} />
          ) : (
            <PageContent {...props} />
          ),
        ),
      [noWrapper],
    );

    return (
      <Wrapper style={{ ...pageContentStyle, ...style }}>
        <CanAccess
          perm={perm}
          fallback={
            <Card size="small">У вас нет прав для доступа к этой странице</Card>
          }
        >
          {children}
        </CanAccess>
      </Wrapper>
    );
  },
);
